<script setup lang="ts">
import { menuList } from './constants/index';

const emit = defineEmits<{
    menuItemClick: [];
}>();
</script>

<template>
    <ul class="menu">
        <li
            v-for="(item, index) in menuList"
            :key="`menu-item-${item}-${index}`"
            class="menu__item"
        >
            <NuxtLink
                :to="item.href"
                class="menu__link"
                @click="emit('menuItemClick')"
            >
                {{ item.title }}
            </NuxtLink>
        </li>
    </ul>
</template>

<style scoped lang="scss">
@import "styles/menu";
</style>
